import { ScrollView, View } from 'react-native';
import { styles } from './GroupedImageToolOptions.styles';
import { ToolOptionsRendererProps } from '../../../BaseToolbar.types';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { ToolOptionsProps } from '../ToolOptionsRenderer.types';
import { observer } from 'mobx-react-lite';
import { GroupedImageToolOption } from './grouped-image-tool-option/GroupedImageToolOption';
import { useStore } from 'src/contexts/StoreContext';
import { NO_GROUP, useGroupedImageToolOptionsLogic } from './GroupedImageToolOptions.logic';

export const GroupedImageToolOptions = observer((props: ToolOptionsRendererProps<ToolOptionsProps>) => {
  const { i18n } = useStore();
  const { isActive, isPriceVisible } = props;

  const {
    groupedOptionsEntries,
    scrollViewRef,
    getScrollViewElementTestId,
    isOptionSelected,
    onPressAndSelectToolOption,
  } = useGroupedImageToolOptionsLogic(props);

  let currentIndexOption = -1;
  return (
    <ScrollView
      style={styles.scrollView}
      ref={scrollViewRef}
      showsVerticalScrollIndicator={true}
      persistentScrollbar={true}
    >
      <View style={styles.containerGroupToolOptions}>
        {groupedOptionsEntries
          .map(([optionGroup, options]) => {
            const optionsRenderer = options.map((option: ToolOptionsProps) => {
              currentIndexOption = currentIndexOption + 1;
              return (
                <View key={option.productOptionChoiceCode} testID={getScrollViewElementTestId(currentIndexOption)}>
                  <GroupedImageToolOption
                    index={currentIndexOption}
                    isActive={isActive}
                    isPriceVisible={isPriceVisible}
                    isDisabled={!option.enabled}
                    optionCode={option.productOptionCode}
                    onPress={async () => onPressAndSelectToolOption(option)}
                    isSelected={isOptionSelected(option)}
                    previewImageUrl={option.previewImageUrl}
                    title={option.titleKey && i18n.t(option.titleKey)}
                    price={option.price}
                    hint={option.hint && i18n.t(option.hint)}
                    isSuboptimal={option.isSuboptimal}
                  />
                </View>
              );
            });

            return optionGroup !== NO_GROUP
              ? [
                  <View key={optionGroup} style={styles.groupTitleContainer}>
                    <TextLato style={styles.groupTitle}>{i18n.t(optionGroup)}</TextLato>
                  </View>,
                  ...optionsRenderer,
                ]
              : optionsRenderer;
          })
          .flat()}
      </View>
    </ScrollView>
  );
});

GroupedImageToolOptions.displayName = 'GroupedImageToolOptions';
